<template>
  <div class="parkState">
    <div class="current">当前位置：园区动态</div>
    <div class="parkStateBox" v-for="i in parkstateData" :key="i.noticeId">
      <div @click="parkStateInfo(i)">
        <div
          style="
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            cursor: pointer; /*鼠标变小手*/
          "
        >
          {{ i.title }}
        </div>
        <div
          style="
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #9e9e9e;
            margin-top: 20px;
            margin-bottom: 27px;
          "
        >
          {{ i.noticeDesc }}
        </div>
      </div>

      <div style="display: flex; align-items: center">
        <img src="../assets/other/time.png" style="width: 24px; height: 24px" />
        <span
          style="
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #9e9e9e;
            margin-left: 10px;
          "
          >{{ i.createTime }}</span
        >
      </div>
    </div>
    <el-pagination
      class="pagination"
      background
      :pageSize="pageSize"
      layout="prev, pager, next"
      :total="total"
      :currentPage="pageNum"
      @current-change="currentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { information } from "../api/home";
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 5,
      noticeType: 1,
      total: 0,
      parkstateData: [],
    };
  },
  methods: {
    currentChange(val) {
      this.pageNum = val;
      this.getParkState();
    },
    getParkState() {
      information({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        noticeType: this.noticeType,
      }).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          this.parkstateData = res.data.rows;
        }
      });
    },
    parkStateInfo(i) {
      this.$router.push({
        name: "policyInfo",
        params: {
          noticeId: i.noticeId,
          type: "park",
        },
      });
    },
  },
  created() {
    this.getParkState();
  },
};
</script>

<style lang="less" scoped>
.parkState {
  padding: 20px 0px 180px 0px;
  width: 1200px;
  margin: 0 auto;
  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 100px;
  }
  .current {
    padding: 30px 0;

    border-bottom: 1px dashed #cccccc;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9e9e9e;
  }
  .parkStateBox {
    padding: 51px 0 25px 0;
    border-bottom: 1px solid #cccccc;
  }
}
</style>